import { defaultDeferIntersectionObserverOptions } from '../common.js';
import { DeferHandler } from './defer-handler.js';
/**
 * A Defer Handler to allow a component to be initialized if the
 *  component is in the viewport.
 */
export class VisibleDeferHandler extends DeferHandler {
    setHandler() {
        if (!('IntersectionObserver' in window)) {
            // runs immediately
            return new Promise((resolve) => {
                resolve();
            });
        }
        return new Promise((resolve) => {
            const observer = new IntersectionObserver((entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    observer.disconnect();
                    resolve();
                }
            }, defaultDeferIntersectionObserverOptions || null);
            observer.observe(this.component);
        });
    }
}
//# sourceMappingURL=visible-defer-handler.js.map